"use strict";

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Rest = require('solid-rest/src/rest.js');

var rest;

function setRestHandlers(handlers) {
  if (typeof handlers != "undefined") {
    rest = new Rest(handlers);
  } else if (typeof rest === "undefined") {
    var File = require('solid-rest/src/file.js');

    var Mem = require('solid-rest/src/localStorage.js');

    rest = new Rest([new File(), new Mem()]);
  }

  return rest;
}

var crossFetch = require('cross-fetch');

var SolidClient = require('@solid/cli/src/SolidClient');

var IdentityManager = require('@solid/cli/src/IdentityManager');

var fs = require('fs');

var path = require('path');

exports.rest = rest;
exports.name = "cli";
exports.fetch = fetch;
exports.currentSession = currentSession;
exports.login = login;
exports.logout = logout;
exports.getCredentials = getCredentials;
exports.setRestHandlers = setRestHandlers;

function fetch(_x, _x2) {
  return _fetch.apply(this, arguments);
}

function _fetch() {
  _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, request) {
    var token;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!url.match(/^(file:|app:)/)) {
              _context2.next = 5;
              break;
            }

            if (typeof rest === "undefined") setRestHandlers();
            _context2.next = 4;
            return rest.fetch(url, request);

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 5:
            request = request || {};
            request.method = request.method || 'GET';
            request.headers = request.headers || {};

            if (!session) {
              _context2.next = 14;
              break;
            }

            _context2.next = 11;
            return client.createToken(url, session);

          case 11:
            token = _context2.sent;
            //         saveIdentityManager(identityManager, settingsFile)
            request.credentials = "include";
            request.headers.authorization = "Bearer ".concat(token);

          case 14:
            return _context2.abrupt("return", crossFetch(url, request));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetch.apply(this, arguments);
}

function logout() {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            session = undefined;
            return _context3.abrupt("return", 1);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _logout.apply(this, arguments);
}

function currentSession() {
  return _currentSession.apply(this, arguments);
}

function _currentSession() {
  _currentSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(session && !client.isExpired(session))) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", session);

          case 4:
            return _context4.abrupt("return", null);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _currentSession.apply(this, arguments);
}

function getCredentials(_x3) {
  return _getCredentials.apply(this, arguments);
}

function _getCredentials() {
  _getCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fn) {
    var creds;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            fn = fn || path.join(homedir, ".solid-auth-cli-config.json");
            creds = {};

            if (!fs.existsSync(fn)) {
              _context5.next = 21;
              break;
            }

            _context5.prev = 3;
            creds = fs.readFileSync(fn, 'utf8');
            _context5.next = 10;
            break;

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](3);
            throw new Error("read file error " + _context5.t0);

          case 10:
            _context5.prev = 10;
            creds = JSON.parse(creds);

            if (creds) {
              _context5.next = 14;
              break;
            }

            throw new Error("JSON parse error : " + err);

          case 14:
            _context5.next = 19;
            break;

          case 16:
            _context5.prev = 16;
            _context5.t1 = _context5["catch"](10);
            throw new Error("JSON parse error : " + _context5.t1);

          case 19:
            _context5.next = 22;
            break;

          case 21:
            creds = {
              idp: process.env.SOLID_IDP,
              username: process.env.SOLID_USERNAME,
              password: process.env.SOLID_PASSWORD,
              base: process.env.SOLID_BASE
            };

          case 22:
            return _context5.abrupt("return", creds);

          case 23:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[3, 7], [10, 16]]);
  }));
  return _getCredentials.apply(this, arguments);
}

var session;
var homedir = require('os').homedir() || "";
var settingsFile = path.join(homedir, '.solid-cli.json');
var identityManager = new IdentityManager();
var client = new SolidClient({
  identityManager: identityManager
}); // OVER-RIDE SOLID-CLI METHOD TO RESOVE BUG
// Fake redirect URL

var redirectUrl = 'http://example.org/';

client.createSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(relyingParty, credentials) {
    var authData, authUrl, loginParams, accessUrl, session;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Obtain the authorization URL
            authData = {};
            _context.next = 3;
            return relyingParty.createRequest({
              redirect_uri: redirectUrl,
              scope: ['openid']
            }, authData);

          case 3:
            authUrl = _context.sent;
            _context.next = 6;
            return this.getLoginParams(authUrl);

          case 6:
            loginParams = _context.sent;
            _context.next = 9;
            return this.performLogin(loginParams.loginUrl, loginParams, credentials);

          case 9:
            accessUrl = _context.sent;
            _context.next = 12;
            return relyingParty.validateResponse(accessUrl, authData);

          case 12:
            session = _context.sent;
            return _context.abrupt("return", session);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

function login(_x6) {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cfg) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (typeof cfg === "string") cfg = undefined; // s-a-client compatability 

            _context6.t0 = cfg;

            if (_context6.t0) {
              _context6.next = 6;
              break;
            }

            _context6.next = 5;
            return getCredentials();

          case 5:
            _context6.t0 = _context6.sent;

          case 6:
            cfg = _context6.t0;

            if (!(typeof cfg.password === "undefined")) {
              _context6.next = 9;
              break;
            }

            throw new Error("Couldn't find login config, please specify environment variables SOLID_IDP, SOLID_USERNAME, and SOLID_PASSWORD or see the README for solid-auth-cli for other login options.");

          case 9:
            _context6.next = 11;
            return client.login(cfg.idp, {
              username: cfg.username,
              password: cfg.password
            });

          case 11:
            session = _context6.sent;

            if (!session) {
              _context6.next = 17;
              break;
            }

            session.webId = session.idClaims.sub;
            return _context6.abrupt("return", session);

          case 17:
            throw new Error("could not log in");

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _login.apply(this, arguments);
}